module.exports = __webpack_public_path__ + "img/opencart.e0efbfc3.svg";